import { render, staticRenderFns } from "./UsageMessages.vue?vue&type=template&id=4d45ad24"
import script from "./UsageMessages.vue?vue&type=script&lang=js"
export * from "./UsageMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d45ad24')) {
      api.createRecord('4d45ad24', component.options)
    } else {
      api.reload('4d45ad24', component.options)
    }
    module.hot.accept("./UsageMessages.vue?vue&type=template&id=4d45ad24", function () {
      api.rerender('4d45ad24', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/usage/UsageMessages.vue"
export default component.exports